<!-- Burbuja flotante (siempre visible cuando cerrada) -->
<button *ngIf="!abierto"
        class="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-gradient-to-br from-red-500 via-red-600 to-rose-700 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all z-50 flex items-center justify-center overflow-hidden"
        (click)="toggle()"
        matTooltip="Asistente IA · pregúntame del módulo en el que estás"
        matTooltipPosition="left">
  <img src="/assets/img/icons/obrero.png" alt="Asistente IA"
       class="w-10 h-10 object-contain drop-shadow-sm" />
  <span *ngIf="unread"
        class="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 border-2 border-white rounded-full animate-pulse"></span>
</button>

<!-- Panel del chat (slide-in derecha) -->
<div *ngIf="abierto"
     class="fixed bottom-0 right-0 sm:bottom-6 sm:right-6 w-full sm:w-[420px] h-[100vh] sm:h-[640px] sm:max-h-[80vh] bg-white sm:rounded-2xl shadow-2xl flex flex-col z-50 border border-gray-200 overflow-hidden">
  <!-- Header -->
  <div class="px-4 py-3 bg-gradient-to-br from-red-600 to-rose-700 text-white flex items-center justify-between">
    <div class="flex items-center gap-3">
      <div class="relative">
        <div class="w-10 h-10 rounded-full bg-white/20 backdrop-blur flex items-center justify-center overflow-hidden">
          <img src="/assets/img/icons/obrero.png" alt="Asistente IA"
               class="w-8 h-8 object-contain" />
        </div>
        <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 border-2 border-red-600 rounded-full"></span>
      </div>
      <div>
        <div class="font-semibold text-sm">Asistente IA</div>
        <div class="text-xs opacity-90 flex items-center gap-1">
          <span class="w-1.5 h-1.5 bg-emerald-300 rounded-full inline-block animate-pulse"></span>
          en línea
        </div>
      </div>
    </div>
    <div class="flex items-center gap-1">
      <!-- Agrandar: abre el asistente dedicado de la empresa del módulo actual
           en ventana grande. La conversación de la burbuja no se pierde: son
           hilos distintos. -->
      <button mat-icon-button (click)="abrirEnVentana()"
              [matTooltip]="'Abrir en ventana grande · Asistente ' + empresaActualLabel()"
              class="!text-white">
        <mat-icon>open_in_full</mat-icon>
      </button>
      <button mat-icon-button (click)="reiniciar()" matTooltip="Nueva conversación"
              class="!text-white">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-icon-button (click)="toggle()" class="!text-white">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Mensajes -->
  <div #chatBox class="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-br from-slate-50 to-white">
    <!-- Cargando historial persistido -->
    <div *ngIf="cargandoHistorial && mensajes.length === 0"
         class="flex flex-col items-center justify-center py-8 text-gray-400">
      <mat-spinner diameter="24"></mat-spinner>
      <div class="text-xs mt-3">Cargando tu conversación...</div>
    </div>

    <ng-container *ngFor="let m of mensajes; trackBy: trackMensaje">
      <!-- Asistente -->
      <div *ngIf="m.role === 'assistant'" class="flex items-start gap-2 max-w-[88%]">
        <div class="flex-shrink-0 w-7 h-7 rounded-full bg-gradient-to-br from-red-500 to-rose-700 text-white flex items-center justify-center text-xs font-bold shadow">
          IA
        </div>
        <div class="flex flex-col gap-2 min-w-0">
          <div class="px-3 py-2 rounded-2xl rounded-tl-sm bg-white border border-gray-200 text-sm leading-relaxed shadow-sm"
               [innerHTML]="formatear(m.content)">
          </div>

          <!-- Cards de acción (Fase 2): preview + Confirmar/Cancelar -->
          <div *ngFor="let a of m.acciones"
               class="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm">
            <div class="flex items-center gap-1.5 font-semibold text-amber-900">
              <mat-icon class="!text-base !w-4 !h-4">bolt</mat-icon>{{ a.titulo }}
            </div>
            <div class="text-amber-800 mt-1 leading-snug">{{ a.resumen }}</div>

            <!-- Sin permiso: no se muestra el botón -->
            <div *ngIf="!a.permitido"
                 class="mt-2 text-xs text-red-700 flex items-start gap-1">
              <mat-icon class="!text-sm !w-4 !h-4 mt-px">lock</mat-icon>
              <span>{{ a.motivoBloqueo }}</span>
            </div>

            <!-- Pendiente de confirmar -->
            <div *ngIf="a.permitido && (!a.estado || a.estado === 'pendiente')"
                 class="mt-3 flex gap-2">
              <button mat-flat-button color="primary" class="!text-xs !min-h-0 !py-1"
                      (click)="confirmarAccion(a)">
                <mat-icon class="!text-base mr-1">check</mat-icon>Confirmar
              </button>
              <button mat-stroked-button class="!text-xs !min-h-0 !py-1"
                      (click)="cancelarAccion(a)">Cancelar</button>
            </div>

            <!-- Estados finales -->
            <div *ngIf="a.estado === 'ejecutando'"
                 class="mt-2 flex items-center gap-2 text-xs text-gray-600">
              <mat-spinner diameter="16"></mat-spinner> Ejecutando…
            </div>
            <div *ngIf="a.estado === 'hecha'"
                 class="mt-2 text-xs text-green-700 flex items-center gap-1">
              <mat-icon class="!text-sm !w-4 !h-4">check_circle</mat-icon>{{ a.resultadoMsg }}
            </div>
            <div *ngIf="a.estado === 'cancelada'" class="mt-2 text-xs text-gray-500">
              Cancelada.
            </div>
            <div *ngIf="a.estado === 'reemplazada'" class="mt-2 text-xs text-gray-400 italic">
              Reemplazada por una propuesta más reciente.
            </div>
            <div *ngIf="a.estado === 'error'" class="mt-2 text-xs text-red-700">
              {{ a.resultadoMsg }}
            </div>
          </div>
        </div>
      </div>

      <!-- Usuario -->
      <div *ngIf="m.role === 'user'" class="flex items-start gap-2 max-w-[88%] ml-auto justify-end">
        <div class="px-3 py-2 rounded-2xl rounded-tr-sm bg-gradient-to-br from-red-500 to-rose-700 text-white text-sm leading-relaxed shadow-sm">
          {{ m.content }}
        </div>
        <div class="flex-shrink-0 w-7 h-7 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center">
          <mat-icon class="!text-base">person</mat-icon>
        </div>
      </div>
    </ng-container>

    <!-- Typing indicator -->
    <div *ngIf="enviando" class="flex items-start gap-2">
      <div class="flex-shrink-0 w-7 h-7 rounded-full bg-gradient-to-br from-red-500 to-rose-700 text-white flex items-center justify-center text-xs font-bold shadow">
        IA
      </div>
      <div class="px-3 py-2 rounded-2xl rounded-tl-sm bg-white border border-gray-200 shadow-sm">
        <div class="flex items-center gap-1">
          <span class="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0ms"></span>
          <span class="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 150ms"></span>
          <span class="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 300ms"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Sugerencias rápidas -->
  <div *ngIf="!enviando && mensajes.length < 4"
       class="px-3 pb-2 flex flex-wrap gap-1.5">
    <button *ngFor="let s of sugerencias()" mat-stroked-button
            class="!text-xs !rounded-full !border-gray-300 hover:!bg-red-50 hover:!border-red-300 hover:!text-red-700"
            (click)="usar(s)">
      {{ s }}
    </button>
  </div>

  <!-- Input -->
  <div class="border-t border-gray-200 p-2 flex items-center gap-2 bg-white">
    <!-- Adjuntar documento. Dentro de un proyecto va a ese; fuera, crea uno nuevo. -->
    <input #docInput type="file" hidden multiple
           accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.mp3,.wav,.m4a,.ogg,.mp4"
           (change)="onArchivoDoc($event)" />
    <button mat-icon-button
            class="!text-gray-500"
            [disabled]="!puedeAdjuntar()"
            (click)="abrirSelectorArchivo(docInput)"
            [matTooltip]="extraerProyectoId() !== null
              ? 'Adjuntar documentos a este proyecto (contrato, pólizas, audio…)'
              : 'Suelta el contrato y las pólizas: creo el proyecto con la IA'">
      <mat-icon>attach_file</mat-icon>
    </button>
    <input
      class="flex-1 px-3 py-2 text-sm outline-none bg-transparent placeholder:text-gray-400"
      [(ngModel)]="inputUsuario"
      (keyup.enter)="enviar()"
      [disabled]="enviando || subiendoDoc"
      placeholder="Pregúntame lo que necesites…" />
    <button mat-mini-fab color="primary"
            [disabled]="enviando || subiendoDoc || !inputUsuario.trim()"
            (click)="enviar()">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
